import CTAHeader, { CTAHeaderPropTypes } from './CTAHeader'

export {
  CTAHeaderPropTypes,
}

export default CTAHeader
